module.exports = __webpack_public_path__ + "static/home-58159f7e73396f5e113db12e64fe5a24.png";